/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTypes } from "../types";
import { getAdministratorFromLocalStorage } from "./validators";
import * as momentFunctions from 'moment';
import moment from "moment";

export const getCurrentApplicationId = () => {
    return 1;
}


export const getOptionsHierarchy = (min: number, max: number): number[] => {
    const length = (max - min) + 1;
    const result = [] as number[];
    for (let i = 0; i < length; i++) {
        result.push(min + i);
    }
    return result;
}

export const getServiceName = (path: string) => {
    const admin = getAdministratorFromLocalStorage();
    const menu = admin.menus.find((x) => {
        return x.services.some((x) => x.route == path);
    });

    if (menu) {
        const service = menu.services.find((y) => {
            return y.route == path
        });

        return { menu: menu.menu, service: service?.service }
    }
}

export const getServiceActions = (type: ActionTypes) => {
    const admin = getAdministratorFromLocalStorage();
    for (const menu of admin.menus) {
        const service = menu.services.find((x) => {
            return x.action.some(y => y.type == type);
        });

        if (service) {
            return {
                menu: menu.menu,
                service: service.service,
                service_path: service.route,
                actions: service.action.filter((x) => x.type == type)
            }
        }
    }
}

export const formatDataToExportPDF = (dataExport: any, fields: any, labels: any) => {
    const valuesExports = [] as string[][];
    const labelExports = [] as any;
    let i = 0;

    for (const item of dataExport) {
        const obj = Object.keys(item)
            .filter(key => fields.includes(key))
            .reduce((obj, key) => {
                obj[labels[key]] = item[key];
                return obj;
            }, {});

        const keys = Object.keys(obj);
        const values = [] as string[];
        keys.map((x) => {
            values.push(obj[x]);
        });

        valuesExports.push(values);

        if (i == 0) {
            labelExports.push(Object.keys(obj));
        }

        i++;
    }

    labelExports[0].reverse();
    for (let i = 0; i < labelExports.length; i++) {
        labelExports[i].reverse();
    }


    return {
        objExports: valuesExports,
        labelExports: labelExports
    }
}

export const convertTimeToSeconds = (time: string) => {
    const [hours, minutes, seconds] = time.split(':').map(Number);

    const validMinutes = Math.min(minutes, 59);
    const validSeconds = Math.min(seconds, 59);

    const totalSeconds = momentFunctions.duration({ hours, minutes: validMinutes, seconds: validSeconds }).asSeconds();
    return totalSeconds;
};

export const convertSecondsToTime = (seconds: number) => {
    if (seconds == 0) {
        return '00:00:00';
    }

    const duration = momentFunctions.duration(seconds, 'seconds');
    const formattedTime = momentFunctions.utc(duration.asMilliseconds()).format('HH:mm:ss');
    return formattedTime;
}

export const getDatesBetween = (startDate: string, endDate: string): string[] => {
    const momentStartDate = moment(startDate, 'YYYY-MM-DD');
    const momentEndDate = moment(endDate, 'YYYY-MM-DD');
    const dates = [] as string[];

    while (momentStartDate.isSameOrBefore(momentEndDate)) {
        dates.push(momentStartDate.format('YYYY-MM-DD'));
        momentStartDate.add(1, 'day');
    }

    return dates;
}

export const dateFormatDateHour = (date) => {
    moment.locale('es');
    return moment(date).format(`YYYY-MM-DD HH:mm:ss`);
}

export const dateFormatYearMonthDay = (date) => {
    moment.locale('es');
    return moment(date).format(`YYYY-MM-DD`);
}

export const dateFormatHourMinuteSecond = (date) => {
    moment.locale('es');
    return moment(date).format(`HH:mm:ss`);
}

export const formatDate = (dateString: string, timeString?: string) => {
    const [year, month, day] = dateString.split('/');
    const time = timeString?.split(':');
    const hours = time ? time[0] : '0';
    const minutes = time ? time[1] : '0';
    const seconds = time ? time[2] : '0';

    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day),
        parseInt(hours), parseInt(minutes), parseInt(seconds));
    return date;
}

export const formatUTCDate = (date: string, time?: string) => {
    if (time) {
        const [year, month, day] = date.split('-');
        const [hours, minutes, seconds] = time.split(':');

        const dateObj = new Date(
            parseInt(year), parseInt(month) - 1, parseInt(day),
            parseInt(hours), parseInt(minutes), parseInt(seconds));

        const dateUTC = moment(dateObj, `YYYY-MM-DD HH:mm:ss`).utc();
        return { date: dateUTC.format('YYYY-MM-DD'), time: dateUTC.format('HH:mm:ss') }
    }
    return { date: date, time: '' };
}

export const dateTransformUtc = (date) => {
    return moment(date, `YYYY-MM-DD HH:mm:ss`).utc().format();
}

export const maskEmail = (email: string): string => {
    const [username, domain] = email.split('@');
    const maskedUsername = username.substring(0, 3) + '*'.repeat(username.length - 5);
    return maskedUsername + '@' + domain;
}

export const parseUserAgent = (userAgent: string): { os: string; browser: string } => {
    const osRegex = /\(([^)]+)\)/;
    const browserRegex = /Chrome\/(\d+\.\d+\.\d+\.\d+)/;

    const osMatch = userAgent.match(osRegex);
    const os = osMatch ? osMatch[1].split(';')[0].trim() : 'Unknown';

    const browserMatch = userAgent.match(browserRegex);
    const browser = browserMatch ? `Chrome ${browserMatch[1]}` : 'Unknown';

    return { os, browser };
}

export const parseBoolean = (value: string): boolean => {
    return value.toLowerCase() === "true";
}

export const sliceToLength = (text: string, maxLength: number): string =>{
     return text.length > maxLength
    ? text.slice(0, maxLength)
    : text;
}